import * as React from 'react';
import { CssBaseline } from "@mui/material";
import Template from "./components/Template";
import Home from './pages/Home';
import Interests from './pages/Interests';
import Research from './pages/Research';
import Resume from './pages/Resume';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Teaching from './pages/Teaching';
import Service from './pages/Service';

function App() {
  return (
    <React.Fragment>
      <CssBaseline />
      <Router>
        <Template>      
          <Routes>
            <Route exact path="/~j_m1758/" element={<Home />} />
            <Route path="/~j_m1758/research" element={<Research />} />
            <Route path="/~j_m1758/teaching" element={<Teaching />} />
            <Route path="/~j_m1758/interests" element={<Interests />} />
            <Route path="/~j_m1758/resume" element={<Resume />} />
            <Route path="/~j_m1758/service" element={<Service />} />
          </Routes>
    </Template>
    </Router>
    </React.Fragment>    
  );
}

export default App;
